import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { FC } from 'react';

interface BreadCrumbProps {
  activeBreadcrumbStyle: string;
  breadcrumbStyle: string;
  fontSize: string;
}

const BreadCrumb: FC<BreadCrumbProps> = ({
  activeBreadcrumbStyle,
  breadcrumbStyle,
  fontSize,
}) => {
  const location = useLocation();
  const breadCrumbView = () => {
    const { pathname } = location;
    const pathnames = pathname.split('/').filter((item) => item);
    return (
      <Breadcrumb separator=">" style={{ color: breadcrumbStyle, fontSize }}>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          return isLast ? (
            <Breadcrumb.Item key={name}>
              <div
                className="capitalize"
                style={{ color: activeBreadcrumbStyle }}
              >
                {name}
              </div>
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item key={name}>
              <Link to={`${routeTo}`}>
                <span className="capitalize" style={{ color: breadcrumbStyle }}>
                  {name}
                </span>
              </Link>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    );
  };

  return <>{breadCrumbView()}</>;
};

export default BreadCrumb;
